const ActionTypeGenerator = action => ({
  WATCH: action,
  LOAD: `${action}_LOAD`,
  FAIL: `${action}_FAIL`,
  SUCCESS: `${action}_SUCCESS`
});

// user
export const SIGN_IN = ActionTypeGenerator("SIGN_IN");
export const SIGN_OUT = ActionTypeGenerator("SIGN_OUT");

// homepage
export const GET_HOMEPAGE_DATA = ActionTypeGenerator("GET_HOMEPAGE_DATA");
export const SET_PRODUCT_CATEGORY = ActionTypeGenerator("SET_PRODUCT_CATEGORY");
export const SET_MOBILE_NAV_VISIBLE = ActionTypeGenerator("SET_MOBILE_NAV_VISIBLE");

// menu
export const GET_MENU_DATA = ActionTypeGenerator("GET_MENU_DATA");
export const SET_MENU_DATA = ActionTypeGenerator("SET_MENU_DATA");

// carousel
export const GET_CAROUSEL_DATA = ActionTypeGenerator("GET_CAROUSEL_DATA");
export const ADD_CAROUSEL_DATA = ActionTypeGenerator("ADD_CAROUSEL_DATA");
export const UPDATE_CAROUSEL_DATA = ActionTypeGenerator("UPDATE_CAROUSEL_DATA");
export const REMOVE_CAROUSEL_DATA = ActionTypeGenerator("REMOVE_CAROUSEL_DATA");

// family
export const GET_FAMILY_DATA = ActionTypeGenerator("GET_FAMILY_DATA");
export const ADD_FAMILY_DATA = ActionTypeGenerator("ADD_FAMILY_DATA");
export const UPDATE_FAMILY_DATA = ActionTypeGenerator("UPDATE_FAMILY_DATA");
export const REMOVE_FAMILY_DATA = ActionTypeGenerator("REMOVE_FAMILY_DATA");

// about
export const GET_ABOUT_DATA = ActionTypeGenerator("GET_ABOUT_DATA");
export const ADD_ABOUT_DATA = ActionTypeGenerator("ADD_ABOUT_DATA");
export const REMOVE_ABOUT_DATA = ActionTypeGenerator("REMOVE_ABOUT_DATA");
export const UPDATE_ABOUT_DATA = ActionTypeGenerator("UPDATE_ABOUT_DATA");

// contact
export const GET_CONTACT_DATA = ActionTypeGenerator("GET_CONTACT_DATA");
export const SET_CONTACT_DATA = ActionTypeGenerator("SET_CONTACT_DATA");

// categories
export const CREATE_CATEGORY = ActionTypeGenerator("CREATE_CATEGORY");
export const UPDATE_CATEGORY = ActionTypeGenerator("UPDATE_CATEGORY");
export const REMOVE_CATEGORY = ActionTypeGenerator("REMOVE_CATEGORY");
export const GET_CATEGOREIS = ActionTypeGenerator("GET_CATEGOREIS");

// products
export const CREATE_PRODUCT = ActionTypeGenerator("CREATE_PRODUCT");
export const REMOVE_PRODUCT = ActionTypeGenerator("REMOVE_PRODUCT");
export const UPDATE_PRODUCT = ActionTypeGenerator("UPDATE_PRODUCT");
export const GET_PRODUCTS = ActionTypeGenerator("GET_PRODUCTS");

// production 
export const GET_PRODUCTION_DATA = ActionTypeGenerator("GET_PRODUCTION_DATA");
export const SET_PRODUCTION_DATA = ActionTypeGenerator("SET_PRODUCTION_DATA");

// footer
export const GET_FOOTER_DATA = ActionTypeGenerator("GET_FOOTER_DATA");
export const SET_FOOTER_DATA = ActionTypeGenerator("SET_FOOTER_DATA");

// SECTIONS NAME/IDS
export const GET_SECTIONS = ActionTypeGenerator("GET_SECTIONS");

export const GET_CERTIFICATES = ActionTypeGenerator("GET_CERTIFICATES");




